import React from "react";
import { Link } from "react-router-dom";

function SideBar() {
    return (
        <div className="sidebar">
            <span className="d-block p-2 sidebar-container">
                <Link to="/productbacklog" className="sidebar-text">
                    Home
                </Link>
            </span>
            <span className="d-block p-2 sidebar-container sidebar-hover">
                <Link to="/productbacklog" className="sidebar-text">
                    Product Backlog
                </Link>
            </span>
            <span className="d-block p-2 sidebar-container">
                <Link to="/scrumboard" className="sidebar-text">
                    Scrum Board
                </Link>
            </span>
            <span className="d-block p-2 sidebar-container">
                <Link to="/teammanagement" className="sidebar-text">
                    Team Management
                </Link>
            </span>
        </div>
    );
}

export default SideBar;
